export const rankToday = [
  { topicId: "topliu-shanye-shanwen", heat: 98600, change: 3 },
  { topicId: "daidai-zhubo-fanche", heat: 82100, change: 1 },
  { topicId: "yinyuejie-yazhou-chidao", heat: 71500, change: -1 },
  { topicId: "zhenrenxiu-jianji-zhengyi", heat: 55300, change: 8 },
  { topicId: "zhedie-ping-liangchan", heat: 64200, change: 0 },
  { topicId: "dianjing-caifang-yanlun", heat: 68900, change: -2 },
  { topicId: "wanghong-canting-paigzu", heat: 58700, change: 5 },
  { topicId: "lianzong-jiabin-xueli", heat: 76300, change: -3 },
];

export const rankWeek = [
  { topicId: "guzhuang-huanjiao-fengbo", heat: 87400, change: 2 },
  { topicId: "topliu-shanye-shanwen", heat: 98600, change: 6 },
  { topicId: "lianzong-jiabin-xueli", heat: 76300, change: -1 },
  { topicId: "laopai-yuedui-chongzu", heat: 61100, change: 12 },
  { topicId: "daidai-zhubo-fanche", heat: 82100, change: -2 },
  { topicId: "dianjing-caifang-yanlun", heat: 68900, change: 4 },
  { topicId: "yinyuejie-yazhou-chidao", heat: 71500, change: -4 },
  { topicId: "zhedie-ping-liangchan", heat: 64200, change: 1 },
];

export const rankMonth = [
  { topicId: "laopai-yuedui-chongzu", heat: 61100, change: 18 },
  { topicId: "guzhuang-huanjiao-fengbo", heat: 87400, change: 9 },
  { topicId: "zhenrenxiu-jianji-zhengyi", heat: 55300, change: 21 },
  { topicId: "topliu-shanye-shanwen", heat: 98600, change: -2 },
  { topicId: "wanghong-canting-paigzu", heat: 58700, change: 7 },
  { topicId: "lianzong-jiabin-xueli", heat: 76300, change: -5 },
  { topicId: "daidai-zhubo-fanche", heat: 82100, change: 3 },
  { topicId: "zhedie-ping-liangchan", heat: 64200, change: -6 },
];